import { withInstall } from '@lit-element/utils'

import Transfer from './src/transfer.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTransfer: SFCWithInstall<typeof Transfer> = withInstall(Transfer)
export default LtTransfer

export * from './src/transfer'
